import React from "react";

import './utils/extend/date.extend';
import './utils/extend/string.extend';
import "./i18n/config";

import { createRoot } from "react-dom/client";
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import "./styles/css/style.css";

import { store } from './redux/store';
import theme from './theme';
import { Provider } from 'react-redux';

import App from "./App";
import { StateProvider } from "./context/UserProvider";
import { AuthMeProvider } from "./context/AuthMeContext";

import { MsalProvider } from '@azure/msal-react';
import * as auth from "./services/authService";
import { AzureADProvider } from "./context/AzureADProvider";
import { ErrorProvider } from "src/context/ErrorProvider";
import { NotificationProvider } from "src/context/NotificationProvider";

const originalFetch = window.fetch.bind(window);

const disableCacheForApiRequests: typeof window.fetch = (input, init) => {
  const sourceUrl = typeof input === "string"
    ? input
    : input instanceof URL
      ? input.href
      : (input as Request).url;
  const method = (
    init?.method ??
    (input instanceof Request ? input.method : "GET") ??
    "GET"
  ).toUpperCase();
  const isApiRequest = sourceUrl.includes("/api/");

  if (!isApiRequest) {
    return originalFetch(input, init);
  }

  const url = new URL(sourceUrl, window.location.origin);
  if (method === "GET" || method === "HEAD") {
    url.searchParams.set("_ts", Date.now().toString());
  }

  const mergedHeaders = new Headers(
    init?.headers ?? (input instanceof Request ? input.headers : undefined)
  );

  mergedHeaders.set("Cache-Control", "no-cache, no-store, must-revalidate");
  mergedHeaders.set("Pragma", "no-cache");
  mergedHeaders.set("Expires", "0");

  const requestInit: RequestInit = {
    ...(typeof input === "string" ? {} : input),
    ...init,
    cache: "no-store",
    headers: mergedHeaders,
  };

  return originalFetch(url.toString(), requestInit);
};

window.fetch = disableCacheForApiRequests;

// Limpio el local storage y el session storage cuando entro
window.onbeforeunload = function() {
  localStorage.clear();
  sessionStorage.clear();
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorProvider>
      <MsalProvider instance={auth.msalInstance}>
        <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <AzureADProvider>
            <NotificationProvider>
              <StateProvider>
                <AuthMeProvider>
                <Provider store={store}>
                    <App />
                  </Provider>
                </AuthMeProvider>
            </StateProvider>
            </NotificationProvider>
          </AzureADProvider>
        </ThemeProvider>
        </StyledEngineProvider>
      </MsalProvider>
    </ErrorProvider>
  </React.StrictMode>
);
